import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    title: {
      paddingBottom: theme.spacing(1),
    },
    disabled: {
      backgroundColor: COLORS.gray.gray90 + ' !important',
    },
  }),
  { name: 'TextArea' }
);
